export default __webpack_public_path__ + "static/media/Deli_Wrong.458aec2f.svg";